module.exports = __webpack_public_path__ + "static/media/Moravsky_Zizkov.1cfd9197.md";